import { render, staticRenderFns } from "./rules-customer.vue?vue&type=template&id=75b7c55c&"
import script from "./rules-customer.vue?vue&type=script&lang=js&"
export * from "./rules-customer.vue?vue&type=script&lang=js&"
import style0 from "./rules-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports